export interface BatchTrcAuthorityUpdateRequest {
  startNumFrom: string
  startNumTo: string
  convertHyoukiToFull: boolean
  convertKanaToHalf: boolean
  inputFileMarc: string
  memo: string
  batchType: string
}

export function BatchTrcAuthorityUpdateRequestToJSON(
  value: BatchTrcAuthorityUpdateRequest
): any {
  return {
    start_num_from: value.startNumFrom,
    start_num_to: value.startNumTo,
    convert_hyouki_to_full: value.convertHyoukiToFull,
    convert_kana_to_half: value.convertKanaToHalf,
    input_file_marc: value.inputFileMarc,
    memo: value.memo,
    batch_type: value.batchType
  }
}
